import React from 'react';
import { Box } from '@mui/material';

const DropZone = ({ onDrop, children, isDragging, disabled }) => {
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled && onDrop) {
      onDrop(e);
    }
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <Box
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      sx={{
        border: '2px dashed',
        borderColor: isDragging ? 'primary.main' : 'divider',
        borderRadius: 1,
        backgroundColor: isDragging ? 'rgba(5, 99, 176, 0.04)' : '#ffffff',
        padding: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        cursor: disabled ? 'default' : 'pointer',
        minHeight: '160px',
        '&:hover': {
          borderColor: !disabled && 'primary.main',
          backgroundColor: !disabled && 'rgba(5, 99, 176, 0.04)',
        },
      }}
    >
      {children}
    </Box>
  );
};

export default DropZone;